import { LoadState } from "../../constants/enums";
import { IPartnerMaster, IPartnerMembership, IBulkActivation, IPartnerPackageMaster, IPartnersState, IPartnerComplaintByMechanicByCity } from "./Partners.types";


export const initialPartnerMaster: IPartnerMaster = {
  partner_master_uuid: "",
  user_uuid: "",
  partner_id: 0,
  partner_prefix: "",
  partner_name: "",
  email: "",
    partner_terms:  [{ key: null, value: null }],
  comment: "",
  is_send_sms: 0,
  is_send_mail: 0,
  activation_key: "",
  referral_code: "",
    pre_determined_value: [{key:"username", value:null}, {key:"contact_number", value:null}],
  allowed_packages: [],
  status: "ACTIVE",
  branch_name: "",
  branch_uuid: "",
  company_outlet_uuid: null,

};


export const initialPartnerMembership: IPartnerMembership = {
  partner_membership_unique_id: 0,
  partner_membership_uuid: "",
  username: "",
  contact_number: "",
  email_id: "",
  state: "",
  city: "",
  area: "",
  pincode: 0,
  address: "",
  vehicle_number: "",
  make_name: "",
  model_name: "",
  registration_year: "",
  package_id: 0,
  package_uuid: "",
  partner_name: "",
  package_name: "",
  package_period: "",
  package_period_type: "",
  package_services: "",
  promo_code: "",
  referral_code: "",
  source: "",
  partner_reference_id: "",
  partner_id: 0,
  partner_uuid: "",
  package_price: 0,
  payment_date: new Date().toISOString(),
  gst_percentage: "",
  gst_amount: 0,
  payment_mode: "",
  membership_code: "",
  payment_status: "",
  total_services: 0,
  remaining_services: 0,
  used_services: 0,
  membership_start_date: new Date().toISOString(),
  membership_expiry_date: new Date().toISOString(),
    additional_details: [{key:null, value:null}],
  customer_fact_uuid: "",
  status: "ACTIVE",
  company_outlet_uuid: "",
  created_by_uuid: null,
  created_by_name: null,
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: new Date().toISOString(),
  insert_ts: new Date().toISOString(),
};

export const initialBulkActivation: IBulkActivation = {
  bulk_activation_unique_id: 0,
  bulk_activation_uuid: "",
  username: "",
  contact_number: "",
  email_id: "",
  address: "",
  vehicle_number: "",
  make_name: "",
  model_name: "",
  registration_year: "",
  user_id: null,
  additional_details: {},
  activation_status: "",
  activation_date: new Date().toISOString(),
  remark: "",
  package_id: 0,
  partner_id: 0,
  partner_uuid: "",
  partner_name: "",
  status: "ACTIVE",
  created_by_uuid: null,
  created_by_name: null,
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: new Date().toISOString(),
  insert_ts: new Date().toISOString(),
};

export const initialPartnerPackageMaster: IPartnerPackageMaster = {
  partner_package_master_uuid: "",
  old_package_id: 0,
  package_order: 0,
  package_id: null,
  package_name: "",
  package_price_excluding_gst: 0,
  package_price: 0,
  gst_percentage: 0,
  gst_amount: 0,
  vehicle_type: "",
  city: null,
  package_location_type: "PAN_INDIA",
  duration: 0,
  duration_type: "",
  package_type: "",
    additional_features: [{key:null, value:null}],
    plan_benefits: [{key: null, value: null}],
  card_url: null,
  partner_id: null,
  partner_uuid: null,
  partner_name: "",
  no_of_services: 0,
  comment: "",
  status: "ACTIVE",
  company_outlet_uuid: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: new Date().toISOString(),
  insert_ts: new Date().toISOString(),
};

export const initialPartnersState: IPartnersState = {
  partnerMaster: {
    list: {
      list: [],
      totalRecords: 0,
      loading: LoadState.NotLoaded,
      error: null,
    },
    data: {
      data: null,
      loading: LoadState.NotLoaded,
      error: null,
    },
  },
  partnerMembership: {
    list: {
      list: [],
      totalRecords: 0,
      loading: LoadState.NotLoaded,
      error: null,
    },
    data: {
      data: null,
      loading: LoadState.NotLoaded,
      error: null,
    },
  },
  bulkActivation: {
    list: {
      list: [],
      totalRecords: 0,
      loading: LoadState.NotLoaded,
      error: null,
    },
    data: {
      data: null,
      loading: LoadState.NotLoaded,
      error: null,
    },
  },
  partnerPackageMaster: {
    list: {
      list: [],
      totalRecords: 0,
      loading: LoadState.NotLoaded,
      error: null,
    },
    data: {
      data: null,
      loading: LoadState.NotLoaded,
      error: null,
    },
  },
  complaintLog: {
    list: {
      list: [],
      totalRecords: 0,
      loading: LoadState.NotLoaded,
      error: null,
    },
  },
  complaintByMechanicByCity: {
    list:{
      list: [],
      totalRecords: 0,
      loading: LoadState.NotLoaded,
      error: null
    }
  },
  complaintReportDetails: {
    list: {
      list: [],
      totalRecords: 0,
      loading: LoadState.NotLoaded,
      error: null,
    },
  },
};
